import IBlock3Others from "./IBlock3Others";
import EnumUtil from "@/app/util/Enum";

export default class Block3Others implements IBlock3Others
{
    constructor(
        public politicallyExposed: string = "",
        public secondaryDocumentType: string = EnumUtil.EMPTY_OPTION,
        public secondaryDocumentNumber: string = "",
        public prefix: string = "",
        public accountNumber: string = "",
        public bankCode: string = "",
        public iban: string = "",
        public academicCardFirstName: string = "",
        public academicCardLastName: string = "",
        public academicCardType: string = EnumUtil.EMPTY_OPTION,
    )
    {
    }
}
